<template lang="pug">

.info-tooltip
  v-icon(size="14") mdi-information-variant

</template>

<script>
import Vue from 'vue'

export default Vue.component('CInfoTooltip', {
  name: 'CInfoTooltip',

  props: {

  },

  data() {
    return {

    }
  },

  computed: {

  },

  methods: {

  }
})

</script>

<style lang="sass" scoped>

.info-tooltip
  display: inline-block
  border: 1px solid gray

</style>